import { render, staticRenderFns } from "./PressForm.vue?vue&type=template&id=1172f0e6&scoped=true&"
import script from "./PressForm.vue?vue&type=script&lang=js&"
export * from "./PressForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1172f0e6",
  null
  
)

export default component.exports